import { render, staticRenderFns } from "./AtomContentSliderBrochure.vue?vue&type=template&id=13b09bb6&scoped=true&"
import script from "./AtomContentSliderBrochure.vue?vue&type=script&lang=js&"
export * from "./AtomContentSliderBrochure.vue?vue&type=script&lang=js&"
import style0 from "./AtomContentSliderBrochure.vue?vue&type=style&index=0&id=13b09bb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b09bb6",
  null
  
)

export default component.exports